import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "@/src/types/IconProps";
import { getIconColor } from "@/src/services/iconService";

const IconOvertime = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m154.18,130.28l-.17-54.82c0-2.97-2.42-5.38-5.39-5.38h-.02c-2.98,0-5.38,2.43-5.38,5.41l.17,54.65c-2.07.72-4.01,1.87-5.69,3.48-4.88,4.69-6.06,11.79-3.52,17.67l-35.27,33.59c-2.16,2.05-2.24,5.47-.19,7.62,1.06,1.11,2.48,1.67,3.91,1.67,1.34,0,2.67-.49,3.72-1.49l35.26-33.58c2.07,1.03,4.34,1.6,6.72,1.65.09,0,.18,0,.28,0,4.1,0,7.98-1.56,10.95-4.41,6.26-6.02,6.45-16,.43-22.26-1.68-1.75-3.68-3.01-5.81-3.81Zm-2.1,18.3c-.94.91-2.17,1.4-3.47,1.4-.03,0-.06,0-.09,0-1.33-.02-2.56-.56-3.48-1.51-1.91-1.99-1.85-5.16.14-7.07.95-.92,2.19-1.37,3.42-1.37,1.31,0,2.63.52,3.61,1.54,1.89,1.97,1.83,5.11-.14,7.01Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m71.39,183.44c-2.58,1.5-3.45,4.8-1.96,7.38,1,1.72,2.81,2.68,4.67,2.68.92,0,1.85-.23,2.7-.73,2.58-1.49,3.46-4.79,1.96-7.37-1.49-2.57-4.79-3.45-7.37-1.96Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m62.53,139.71c-2.97,0-5.39,2.42-5.39,5.39.01,2.98,2.42,5.39,5.41,5.39s5.39-2.42,5.38-5.4c0-2.98-2.42-5.39-5.4-5.38Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m71.3,106.73c.85.49,1.78.72,2.69.72,1.87,0,3.68-.97,4.68-2.7,1.49-2.58.61-5.88-1.97-7.37-2.59-1.49-5.88-.6-7.37,1.98s-.61,5.88,1.97,7.37Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m188.82,75.03h0c.85.5,1.77.73,2.68.73,1.87,0,3.69-.97,4.69-2.71,1.48-2.58.6-5.88-1.99-7.36-2.58-1.49-5.87-.6-7.36,1.98s-.6,5.88,1.98,7.36Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m223.08,107.2c.92,0,1.85-.24,2.71-.74,2.57-1.49,3.45-4.79,1.95-7.37-1.5-2.57-4.8-3.45-7.37-1.95-2.58,1.49-3.45,4.8-1.96,7.37,1,1.72,2.81,2.69,4.67,2.69Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m105.46,75.9c.92,0,1.85-.23,2.71-.73,2.57-1.49,3.45-4.79,1.95-7.37-1.5-2.57-4.8-3.45-7.37-1.95-2.58,1.49-3.46,4.79-1.96,7.37,1,1.72,2.81,2.68,4.67,2.68Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m148.46,64.32h0c2.98-.01,5.39-2.42,5.39-5.4-.01-2.98-2.43-5.39-5.41-5.39-2.98,0-5.39,2.42-5.38,5.41,0,2.97,2.41,5.38,5.39,5.38Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m234.69,150.39c2.97,0,5.39-2.41,5.39-5.39v-.21c0-2.98-2.43-5.39-5.41-5.38-2.98,0-5.39,2.42-5.38,5.4h0v.19c0,2.98,2.41,5.39,5.4,5.39Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m148.66,225.68c-2.98,0-5.4,2.42-5.39,5.4,0,2.97,2.41,5.38,5.39,5.38s5.39-2.41,5.39-5.39-2.42-5.39-5.39-5.39Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m108.32,214.91h0c-2.58-1.49-5.88-.6-7.37,1.98s-.6,5.87,1.97,7.37h0c.85.49,1.77.72,2.69.72,1.86,0,3.68-.97,4.68-2.7,1.49-2.58.6-5.88-1.98-7.37Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m66.97,49.23c1.19,0,2.39-.39,3.39-1.2.99-.8,2-1.59,3.02-2.36,2.37-1.8,2.83-5.19,1.03-7.56-1.8-2.37-5.19-2.83-7.56-1.03-1.1.84-2.19,1.69-3.27,2.55-2.32,1.87-2.68,5.27-.81,7.58,1.07,1.32,2.63,2,4.2,2Z"
      />
      ;
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m277.73,185.76c4.07-12.87,6.27-26.56,6.27-40.76,0-74.66-60.74-135.39-135.39-135.39-23.94,0-47.47,6.33-68.05,18.32-2.57,1.5-3.45,4.8-1.95,7.38,1.5,2.57,4.8,3.45,7.38,1.95,18.93-11.03,40.58-16.85,62.62-16.85,68.71,0,124.61,55.9,124.61,124.61,0,11.31-1.52,22.26-4.36,32.69-3.09-2.32-6.36-4.34-9.79-6.03,8.73-36.44-.68-76.46-28.53-105.42-21.05-21.89-49.36-34.27-79.7-34.87-30.36-.63-59.11,10.66-80.99,31.71-45.18,43.44-46.59,115.54-3.14,160.72,22.27,23.16,52.07,34.81,81.92,34.81,8.96,0,17.92-1.05,26.68-3.15,1.67,3.4,3.68,6.68,6.01,9.79-10.43,2.84-21.39,4.36-32.7,4.36-68.71,0-124.61-55.9-124.61-124.61,0-31.09,11.52-60.87,32.44-83.85,2-2.2,1.84-5.61-.36-7.62-2.2-2.01-5.61-1.84-7.62.36-22.73,24.97-35.25,57.33-35.25,91.12,0,74.66,60.74,135.39,135.39,135.39,14.2,0,27.89-2.2,40.76-6.27,11.21,10.21,25.55,15.96,40.84,16.26.42,0,.83.01,1.25.01,16.25,0,31.6-6.18,43.35-17.48,12.05-11.58,18.86-27.17,19.19-43.87.31-16.11-5.46-31.41-16.26-43.28Zm-106.35,59.51c-7.49,1.69-15.12,2.55-22.75,2.55-27.01,0-53.99-10.55-74.14-31.5-39.32-40.89-38.05-106.15,2.84-145.47,19.31-18.57,44.53-28.72,71.23-28.72.69,0,1.38,0,2.08.02,27.47.54,53.09,11.75,72.14,31.56,24.85,25.84,33.47,61.41,26.14,94.01-5.22-1.51-10.67-2.36-16.24-2.47-16.72-.36-32.54,5.87-44.59,17.46-17.31,16.65-22.94,40.94-16.69,62.56Zm95.96,19.86c-9.97,9.59-23.07,14.76-36.91,14.46-13.83-.27-26.72-5.91-36.31-15.88-19.79-20.58-19.15-53.43,1.43-73.23,9.72-9.35,22.42-14.46,35.86-14.46.35,0,.7,0,1.04,0,13.83.27,26.72,5.92,36.31,15.89,9.59,9.97,14.72,23.07,14.45,36.9-.27,13.83-5.91,26.72-15.88,36.31Z"
      />
      ;
      <polygon
        style={{ fill: getIconColor(active, theme) }}
        points="239.89 203.21 222.99 203.21 222.99 219.37 206.83 219.37 206.83 236.27 222.99 236.27 222.99 252.44 239.89 252.44 239.89 236.27 256.06 236.27 256.06 219.37 239.89 219.37 239.89 203.21"
      />
      ;
    </SvgIcon>
  );
};

export default IconOvertime;
